import { SecureClient } from '../../../utils';

const getMandatesListAPICall = ({
  customerCredentials,
  payload,
  successFn,
  errorFn,
  finallyFn,
}) => {
  const { customerId, Authorization, customerRefNum } = customerCredentials;
  SecureClient({
    isEncrypted: true,
    customerId,
    route: 'customerkyc/getmandateslist',
    payload,
    otherPayloadDetailsPresent: true,
    headers: { Authorization },
    method: 'POST',
    successFn,
    errorFn,
    finallyFn,
  });
};

export default getMandatesListAPICall;
